import { render, staticRenderFns } from "./PersonalResultHistory.vue?vue&type=template&id=6f1a6af2&scoped=true&"
import script from "./PersonalResultHistory.vue?vue&type=script&lang=js&"
export * from "./PersonalResultHistory.vue?vue&type=script&lang=js&"
import style0 from "./PersonalResultHistory.vue?vue&type=style&index=0&id=6f1a6af2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../frontend-internal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1a6af2",
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend-internal/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BButton, BRow} from 'bootstrap-vue'
    installComponents(component, {BCol, BButton, BRow})
    


    import installDirectives from "!/Users/jurajpetras/dev/pmat/web/frontend-internal/node_modules/bootstrap-vue-loader/lib/runtime/installDirectives.js"
    import {VBPopover} from 'bootstrap-vue'
    installDirectives(component, {'b-popover': VBPopover})
    

export default component.exports